import ArticleLayout from "@/components/feature/ArticleLayout";
import { articles } from "@/mocks/articles";

const article = articles[0];

export default function Article() {
  return (
    <ArticleLayout
      title={article.title}
      description={article.excerpt}
      date={article.date}
      readTime={article.readTime}
      imageUrl={article.imageUrl}
      keywords="CSSBuy, como usar CSSBuy, guia CSSBuy 2026, agente de compras China, CSSBuy tutorial português"
      articleSchemaName="CSSBuy Spreadsheet"
      faqItems={article.faq}
    >
      <p>
        Se chegaste aqui, provavelmente já ouviste falar do CSSBuy e queres saber como funciona. Este guia completo vai ensinar-te tudo o que precisas para começar a comprar da China com o CSSBuy em 2026.
      </p>

      <h2>O que é o CSSBuy?</h2>
      <p>
        O <strong>CSSBuy</strong> é um agente de compras chinês que te permite adquirir produtos de plataformas como Taobao, Weidian, 1688 e Tmall. Funciona como intermediário: tu escolhes o produto, o CSSBuy compra por ti, armazena no armazém deles e depois envia para a tua morada em Portugal ou no Brasil. É a forma mais segura e prática de comprar da China sem barreiras linguísticas.
      </p>

      <h2>Passo 1: Criar a Tua Conta CSSBuy</h2>
      <p>
        O primeiro passo é criar uma conta gratuita no CSSBuy. O processo é simples e demora menos de 2 minutos. Precisas apenas de um email válido e uma palavra-passe segura. Após o registo, recebes um email de confirmação. Recomendamos usar um email que consultes regularmente, pois é por lá que recebes as notificações de compra e QC.
      </p>

      <h2>Passo 2: Encontrar Produtos</h2>
      <p>
        Esta é a parte mais importante. Usa a nossa <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow">CSSBuy Spreadsheet</a> para encontrar links verificados de produtos. A planilha está organizada por categorias: calçados, moletons, t-shirts, jaquetas, calças, bonés, conjuntos, roupa interior, jerseys, acessórios, malas, cintos, perfumes e outros. Cada link foi testado e verificado pela nossa equipa.
      </p>

      <h2>Passo 3: Copiar e Colar o Link</h2>
      <p>
        Depois de encontrares o produto que queres, copia o link e cola na barra de pesquisa do CSSBuy. A plataforma reconhece automaticamente a origem do link (Taobao, Weidian, etc.) e carrega os detalhes do produto: nome, fotos, opções disponíveis e preço.
      </p>

      <h2>Passo 4: Escolher Opções e Pagar</h2>
      <p>
        Seleciona as opções que queres (tamanho, cor, modelo) e adiciona ao carrinho. O CSSBuy mostra o preço em yuan (CNY) e faz a conversão automática. Podes pagar com PayPal, cartão de crédito ou outros métodos disponíveis. O valor inclui o preço do produto + taxa de serviço do CSSBuy.
      </p>

      <h2>Passo 5: Aguardar QC e Envio</h2>
      <p>
        Após a compra, o vendedor envia o produto para o armazém do CSSBuy. Quando chega, a equipa do CSSBuy tira fotos de QC (Quality Control). Podes ver as fotos e decidir se queres manter o produto ou devolver. Se aprovares, escolhes o método de envio e pagas o frete. Para Portugal, os prazos variam entre 15 e 30 dias.
      </p>

      <h2>Dicas para Principiantes</h2>
      <ul>
        <li>Começa com produtos baratos para testar o processo</li>
        <li>Usa sempre a nossa <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow">planilha CSSBuy</a> com links verificados</li>
        <li>Lê os guias disponíveis no nosso site antes de comprar</li>
        <li>Verifica as avaliações do vendedor no Taobao/Weidian</li>
        <li>Não tenhas pressa - o envio da China demora algumas semanas</li>
      </ul>
    </ArticleLayout>
  );
}